import api from './api';

export const workflowService = {
  // Process workflow action (staff/officer operations)
  processApplication: async (applicationId, action, data) => {
    const response = await api.post(`/workflow/process/${applicationId}/${action}`, data);
    return response.data;
  },

  // Get workflow history for application
  getWorkflowHistory: async (applicationId) => {
    const response = await api.get(`/workflow/history/${applicationId}`);
    return response.data;
  },

  // Get current user's workload
  getWorkload: async () => {
    const response = await api.get('/workflow/workload');
    return response.data;
  },
};
